import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 12,
    padding: 16
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 8
  },
  row2: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    marginBottom: 16
  }
}))

export default useStyles
